import nmaps from "./nmaps.js";
import Stacker from "./stacker.js";
import Alea from "alea";

var transform_functions = {
  _get_map: function (v) {
    if (typeof v === "string") {
      if (nmaps[v]) {
        return nmaps[v];
      }
      return {};
    }
    return v;
  },
  _in_map: function (str, _map) {
    if (!str) return false;
    var map = this._get_map(_map);
    var chars = Object.keys(map).map(function (c) {
      return String.fromCodePoint(c);
    });
    var ok = Array.from(str).some(function (strchar) {
      if (chars.indexOf(strchar) > -1) {
        return true;
      }
      return false;
    });
    return ok;
  },
  prepend_global: function (str, a) {
    let result = String.fromCodePoint.apply(null, a.chars) + str;
    return result;
  },
  append: function (str, a) {
    return Array.from(str, function (c) {
      if (!a.except || a.except.indexOf(c) === -1) {
        c += String.fromCodePoint.apply(null, a.chars);
      }
      return c;
    }).join("");
  },
  shift_code_point: function (str, a) {
    return Array.from(str, function (str) {
      var strCode = str.codePointAt();
      if (strCode >= a.range[0] && strCode <= a.range[1]) {
        return String.fromCodePoint(str.codePointAt() + a.add);
      }
      return str;
    }).join("");
  },
  map_code_point: function (str, a) {
    var ok = true;
    var map = this._get_map(a.map);
    var repeat_count = a.repeat_count || 1;
    if (a.if_in_map) {
      ok = this._in_map(str, a.if_in_map);
    }
    if (map && ok) {
      var replacements = 0;
      var str_array = Array.from(str);
      return str_array
        .map(function (c, i) {
          var strCode = c.codePointAt();
          if (map[strCode]) {
            var newChar;
            if (typeof map[strCode][0] == "object") {
              newChar = String.fromCodePoint.apply(
                null,
                map[strCode][replacements++ % map[strCode].length]
              );
            } else {
              newChar = String.fromCodePoint.apply(null, map[strCode]);
            }
            if (a.append && typeof a.append == "boolean") {
              newChar = c + newChar;
            } else if (a.append) {
              newChar = String.fromCodePoint.apply(null, a.append) + newChar;
            }
            if (a.prepend) {
              newChar = newChar + c;
            }
            if (repeat_count > 1 && i + 1 - repeat_count >= 0) {
              let repeated_items = str_array.slice(i + 1 - repeat_count, i + 1);
              ok = repeated_items.every((val, ai, arr) => val === arr[0]);
            }
            return ok ? newChar : c;
          }
          return c;
        })
        .join("");
    } else {
      return str;
    }
  },
  reverse: function (str, a) {
    var ok = true;
    if (a.if_in_map) {
      ok = this._in_map(str, a.if_in_map);
    }
    if (ok) {
      return Array.from(str).reverse().join("");
    }
    return str;
  },
  replace_all: function (str, a) {
    return str.replace(/([^\s])/g, String.fromCodePoint(a.char));
  },
  wrap: function (str, a) {
    var split_char = String.fromCodePoint(a.split_char);
    var wrap_char = String.fromCodePoint.apply(null, a.wrap_char);
    return str
      .split(split_char)
      .map(function (w) {
        return wrap_char + w + wrap_char;
      })
      .join(split_char);
  },
  stack: function (str, a) {
    return Stacker.make(str);
  },
  normalize: function (str, a) {
    if (!String.prototype.normalize) return str;
    return str.normalize(a.type);
  },
  strip_diacritics: function (str) {
    return str.replace(/[\u0300-\u036f]/g, "");
  },
  unstack: function (str) {
    return Stacker.unstack(str);
  },
  remove_extra_spaces: function (str) {
    return str.replace(/ +(?= )/g, "");
  },
  rand: (str, a) => {
    const { actions, seed } = a;
    const prng1 = new Alea(seed + str);
    return Array.from(str, function (c) {
      const subActions = actions[(actions.length * prng1()) | 0];
      subActions.forEach(function (action) {
        c = transform_functions[action.action](c, action);
      });
      return c;
    }).join("");
  },
  cycle: (str, a) => {
    const { actions } = a;
    return Array.from(str, function (c, i) {
      const subActions = actions[(i + str.length - 1) % actions.length];
      subActions.forEach(function (action) {
        c = transform_functions[action.action](c, action);
      });
      return c;
    }).join("");
  },
  char_echo: (str, a) => {
    const { actions } = a;
    return Array.from(str, function (c, ci) {
      let newC = "";
      actions.forEach((subActions) => {
        subActions.forEach((action) => {
          if (action.seed) {
            action = Object.assign({}, action);
            action.seed += `${ci}${str}`;
          }
          newC += transform_functions[action.action](c, action);
        });
      });
      return newC;
    }).join("");
  },
};

export default transform_functions;
